import React, { Component } from "react";

 
const Index = ({
    params,
}) => (
    <div></div>
);

export default Index;



// WEBPACK FOOTER //
// ./src/pages/Index.js